import { render } from "./DS100GroupCallMenu.vue?vue&type=template&id=45a697ed&scoped=true"
import script from "./DS100GroupCallMenu.vue?vue&type=script&lang=js"
export * from "./DS100GroupCallMenu.vue?vue&type=script&lang=js"

import "./DS100GroupCallMenu.vue?vue&type=style&index=0&id=45a697ed&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a697ed"]])

export default __exports__